export const dateTimeFunc = {
  lastDayOfMounth: () => {
    const now = new Date()
    const currentDay = now.getDate()
    const lastDayOfMonth = new Date(
      now.getFullYear(),
      now.getMonth() + 1,
      0
    ).getDate()

    const lastDayConfig = lastDayOfMonth

    return {
      isLastDayOfMonth: currentDay === lastDayConfig,
      lastDayOfMonth: lastDayConfig,
    }
  },
  // time 24 hour
  blockTimeEveryLastDayOfMonth: ({ start, startMinute, end, endMinute }) => {
    const now = new Date()
    const currentDay = now.getDate()
    const currentHour = now.getHours()
    const currentMinute = now.getMinutes()
    const isEndOfMonth =
      currentDay === dateTimeFunc.lastDayOfMounth().lastDayOfMonth
    const isBlockedTime =
      (currentHour === start && currentMinute >= startMinute) ||
      (currentHour > start && currentHour < end) ||
      (currentHour === end && currentMinute <= endMinute)

    return isEndOfMonth && isBlockedTime
  },
}
